var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"contactsBlock"},[_c('delegates',{attrs:{"access-edit":_vm.accessEdit,"value":_vm.value},on:{"update:value":function($event){_vm.value=$event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }